/* eslint-disable import/prefer-default-export,quote-props,consistent-return */
import axios from 'axios';
import conf from '../../conf/conf';

const tokenKey = 'tvToken';

const authHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/x-www-form-urlencoded',
  'cache-control': 'no-cache'
};

const jsonHeaders = {
  'Accept': '*/*',
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache'
};

class TvCommunicate {
  static getToken = () => JSON.parse(window.localStorage.getItem(tokenKey));

  static setToken = (data) => window.localStorage.setItem(tokenKey, JSON.stringify(data));

  getHeaders = () => ({
    ...jsonHeaders,
    Authorization: `Bearer ${this.constructor.getToken().access_token}`
  });

  isAuth = () => !!this.constructor.getToken();

  transformRequest = (jsonData = {}) => Object.entries(jsonData).map(
    (x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`
  ).join('&');

  reAuthCompany = () => this.authCompany(this.constructor.getToken().client_id);

  authCompany(clientId) {
    const data = {
      grant_type: 'client_credentials',
      scope: 'CompuAccess',
      client_secret: '2111120a122ee68e3dd4ffb5c6971539a78efa2bb55047f20bb39cb75745c143',
      client_id: clientId
    };
    const requestData = this.transformRequest(data);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `${conf.identityPath}connect/token`,
        data: requestData,
        headers: authHeaders
      })
        .then((response) => {
          const recordData = {
            ...response.data,
            client_id: clientId
          };
          this.constructor.setToken(recordData);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  request = (params) => {
    const url = params.url;
    const method = params.method || 'get';
    const data = params.data || {};
    const getData = params.getParams || '';
    const responseType = params.responseType || '';
    const headers = this.getHeaders();
    let responseData = {};

    switch (method) {
      case 'get':
      case 'delete': {
        responseData = {
          method,
          url: conf.api + url + getData,
          responseType,
          headers
        };
        break;
      }
      case 'post':
      case 'put': {
        responseData = {
          method,
          url: conf.api + url + getData,
          data,
          headers
        };
        break;
      }
      default:
        return {};
    }

    return new Promise((resolve, reject) => {
      axios(responseData)
        .then((resp) => resolve(resp))
        .catch((err) => {
          if (err.response.status === 401) {
            this.reAuthCompany()
              .then(() => {
                axios({
                  ...responseData,
                  headers: this.getHeaders()
                })
                  .then((response) => resolve(response))
                  .catch((error) => reject(error));
              });
          } else {
            reject(err);
          }
        });
    });
  };
}

const tvCommunicate = new TvCommunicate();

export default tvCommunicate;
